<template lang="pug">
p(:style="labelStyles")
    slot
        | {{ label }}
        span(v-if="mandatory", :style="mandatoryStyles") *
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  name: "FieldLabel",
  props: ["mandatory", "label"],
  computed: {
    labelStyles(): object {
      return {
        fontFamily: "system-ui !important",
        color: this.$vuetify.theme.themes.light.primary,
        fontWeight: 400,
        marginBottom: 0,
      }
    },
    mandatoryStyles(): object {
      return {
        color: "red",
        fontWeight: 400,
      }
    },
  },
})
</script>
